import { authFetch } from "../../api";

export const createSAPEnrollEnquiry = async (requestData) => {
  try { 
    const response = await authFetch("sap-enroll/create-sap-enquiry", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    let data;

    data = await response.json();
    return data;
  } catch (err) {
    console.error("can't create enquiry  :", err.message);
  }
};